var registerSteps = /** @class */ (function () {
    function registerSteps() {
    }
    registerSteps.STORE_MODULE_NAME = 'registerSteps';
    return registerSteps;
}());
export { registerSteps };



//////////////////
// WEBPACK FOOTER
// ./src/plugins/registerSteps/lib/registerSteps.cls.ts
// module id = null
// module chunks = 